<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.adminManagement') }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="row">
                    <div class="col-lg-4" v-if="hasAdminRole">
                        <router-link :to="{ name: 'medical-files' }" >
                            <stats-card
                                    :title="$tc('message.medicalFiles', 2)"
                                    type="gradient-teal"
                                    icon="fas fa-file-medical-alt"
                                    class="mb-4"
                            ></stats-card>
                        </router-link>
                    </div>


                    <div class="col-lg-4" v-if="can">
                        <router-link :to="{ name: 'affiliations' }">
                            <stats-card
                                    :title="$tc('message.affiliations', 2)"
                                    type="gradient-pink"
                                    icon="fas fa-link"
                                    class="mb-4"
                            ></stats-card>
                        </router-link>
                    </div>

                    <div class="col-lg-4" v-if="can">
                        <router-link :to="{ name: 'professions' }">
                            <stats-card
                                    :title="$tc('message.professions', 2)"
                                    type="gradient-cyan"
                                    icon="fas fa-user-tie"
                                    class="mb-4"
                            ></stats-card>
                        </router-link>
                    </div>

                    <div class="col-lg-4" v-if="can">
                        <router-link :to="{ name: 'specialties' }">
                            <stats-card
                                    :title="$tc('message.specialties', 2)"
                                    type="gradient-green"
                                    icon="fas fa-briefcase-medical"
                                    class="mb-4"
                            ></stats-card>
                        </router-link>
                    </div>

                    <div class="col-lg-4" v-if="can || hasAssistante">
                        <router-link :to="{ name: 'institutions' }">
                            <stats-card
                                    :title="$tc('message.institutions', 2)"
                                    type="gradient-purple"
                                    icon="fas fa-clinic-medical"
                                    class="mb-4 mb-xl-0"
                            ></stats-card>
                        </router-link>
                    </div>
                    <div class="col-lg-4" v-if="can">
                        <router-link :to="{ name: 'drugs' }">
                            <stats-card
                                    :title="$tc('message.drug',2)"
                                    type="gradient-blue"
                                    icon="fas fa-tablets"
                                    class="mb-4 mb-xl-0"
                            ></stats-card>
                        </router-link>
                    </div>

                    <div class="col-lg-4" v-if="can || hasMedecinControleRole || hasAssistante">
                        <router-link :to="{ name: 'accountants' }">
                            <stats-card
                                :title="$tc('message.comptable',1)"
                                type="gradient-pink"
                                icon="fas fa-calculator"
                                class="mb-4 mb-xl-0"
                            ></stats-card>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "MedicalManagement",
        computed: {
            ...mapGetters(['hasAdminRole','hasGestionnaireRole','hasMedecinControleRole','hasAssistante']),

            can:function () {
                return this.hasAdminRole || this.hasGestionnaireRole;
            }
        }
    }
</script>

<style scoped>

</style>
